import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { ShimmerLabel } from "./ShimmerLabel";
import { TypingDots } from "./TypingDots";

interface ThinkingIndicatorProps {
  readonly className?: string;
  label: string;
}

export const ThinkingIndicator = ({
  label,
  className,
}: ThinkingIndicatorProps) => (
  <div className={classNames("flex items-center gap-2", className)}>
    <TypingDots />
    <ShimmerLabel label={label} />
  </div>
);
